module.exports = __webpack_public_path__ + "img/safe-payment-icon-grey.b9a790ae.svg";